/**
 * A job page link. getJobs strips the type prefix from job_id, so the type
 * goes in ?type= to tell lambda:x from terraform:x.
 */
export const jobPath = (app: string, jobId: string, type?: string): string =>
  `/jobs/${encodeURIComponent(app)}/${encodeURIComponent(jobId)}` +
  (type ? `?type=${encodeURIComponent(type)}` : '');
